
import { defineComponent } from "vue";
import { mapActions, mapState } from "vuex";
import PorqueNosotrosVue from "@/components/PorqueNosotros.vue";
import TeacherCard from "@/components/TeacherCard.vue";
import CursosOnMainPage from "@/components/CursosOnMainPage.vue";
import SobreElCentroOnMainPage from "@/components/SobreElCenroOnMainPage.vue";
import ContactosOnMainPage from "@/components/ContactosOnMainPage.vue";

export default defineComponent({
  name: "Home",
  components: { PorqueNosotrosVue, TeacherCard, CursosOnMainPage, SobreElCentroOnMainPage, ContactosOnMainPage },
  computed: {
    ...mapState(["teachers"]),
  },
  methods: {
    ...mapActions(["getTeachersFromApi"]),
  },
  mounted() {
    this.getTeachersFromApi();
  },
});
